<template>
  <div>
    <app-button-create
      class="border-blue mb-5"
      color="blue"
      @click="newPoliticalAction"
      :hidden="currentUser.role_id !== 1"
    >
      <span class="text-blue font-bold text-lg">政務活動</span>
      <span class="text-blue text-sm">を</span>
      <span class="text-blue font-bold text-lg">新規追加</span>
    </app-button-create>
    <activities-table-header></activities-table-header>
    <activities-table v-if="renderComponent"></activities-table>

    <activities-dialog
      v-if="isOpen && type === 'politicalAction'"
    ></activities-dialog>
  </div>
</template>

<script>
import { onBeforeMount, watch, ref, nextTick } from 'vue'
import AppButtonCreate from '@/components/ui/AppButtonCreate'
import ActivitiesTableHeader from '@/components/layout/activitiesToda/ActivitiesTableHeader'
import ActivitiesTable from '@/components/layout/activitiesToda/ActivitiesTable'
import ActivitiesDialog from '@/components/layout/activitiesToda/ActivitiesDialog'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import { useRequestForm } from '@/services/politicalActionToda/useRequestForm'
import { useDialog } from '@/services/useDialog'
import { useYearSelector } from '@/services/useYearSelector'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'Activities_TODA',

  components: {
    ActivitiesTableHeader,
    ActivitiesTable,
    AppButtonCreate,
    ActivitiesDialog,
  },

  setup() {
    const {
      getUsers,
      // getActivities,
      resetCurrentPoliticalAction,
      activitiesState,
    } = usePoliticalActions()
    const { activityDialog } = usePoliticalActionDialog()
    const { resetActionTypes } = useRequestForm()
    const { currentYear, resetYear } = useYearSelector()
    const { openDialog, isOpen, type } = useDialog()
    const { currentUser } = useCurrentUser()

    const renderComponent = ref(true)

    // 年度を変更したときにreceiptsTableをmountし直す
    const reRenderComponent = () => {
      renderComponent.value = false
      nextTick(() => {
        renderComponent.value = true
      })
    }

    watch(currentYear, (currentYear, newval) => {
      if (currentYear != newval) reRenderComponent()
    })

    onBeforeMount(async () => {
      await resetYear()
      await getUsers()
    })

    // onMounted(async () => {
    //   resetYear()
    //   await getActivities(currentYear.value)
    //   await getUsers()
    // })

    // watch(currentYear, async currentYear => {
    //   await getActivities(currentYear)
    // })

    const newPoliticalAction = () => {
      resetActionTypes()
      resetCurrentPoliticalAction()
      openDialog('politicalAction')
      activityDialog.currentDocumentType = 'request'
      activityDialog.isPreview = false
      activityDialog.isPreviewEnabled = false
      activityDialog.isPreviewResult = false
      activityDialog.isPreviewResultEnabled = false
      activityDialog.isPreviewMemory = false
      activityDialog.isPreviewMemoryEnabled = true
      activityDialog.isPreviewImg = false
      activityDialog.isSaveMemoryItemForm = false
      activityDialog.isOffice = false
      activityDialog.isOfficeResult = false
      activityDialog.isOfficeMemory = false
    }

    return {
      newPoliticalAction,
      isOpen,
      type,
      currentUser,
      resetActionTypes,
      getUsers,
      activitiesState,
      renderComponent,
      ...usePoliticalActionDialog(),
    }
  },
}
</script>

<style lang="scss"></style>
